import {useState, useEffect} from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import LocatorListItemReel from "./LocatorListItemReel";
import LocatorListItemCurLocation from './LocatorListItemCurLocation';
import LocatorListItemProduct from './LocatorListItemProduct';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function LocatorListItem(props){
    //console.debug("RTS Break LocatorListItem");

    const {user} = useSessionContext();


    const styleHeaders = {
        textAlign: 'center',
        borderBottom: '2px solid #1976d2'
    }


    const[data, setData] = useState(props.data);


    useEffect(() => {
        setData(props.data);
    }, [props.data]);    


    return (
        <Paper elevation={4} sx={{p:2, boxShadow:"0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,1), 0px 1px 10px 0px rgba(0,0,0,0.22)"}} id="loadListItemPaper">
            {user.adminFlag === 1
                ?
                    <Box>
                        <Typography variant='caption'>{data.idGuid}</Typography>
                    </Box>
                :
                    ''
            }
            <Grid container>          
                <Grid item xs={9} sx={{textAlign:'left'}}>
                    {data.curOwner == null
                    ?
                        <Typography variant="h6" sx={{fontWeight:"bold", fontSize:"1em", color:"Red"}}>Not Available</Typography>
                    :
                        <Typography variant="h6" sx={{fontWeight:"bold", fontSize:"1em"}}>{data.curOwner}</Typography>
                    }
                </Grid>
            </Grid>
            <Grid container spacing={2} id="mainGrid">
                <Grid item xs={12} sm={7} md={props.hideLinks!==true?6:8} lg={props.hideLinks!==true?7:9}>
                    <Stack>
                        <Box sx={{...styleHeaders, display:'flex', alignItems:'center', justifyContent:'center'}}>
                            <Typography variant="h6">Product</Typography>
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={6} lg={4}>
                                <LocatorListItemProduct data={data} />
                            </Grid>

                            <Grid item xs={6} lg={4}>
                                <Stack>
                                    <Box sx={{display:'flex'}}>
                                        <Typography variant="body2" sx={{fontWeight:'bold'}}>Purchased:</Typography>
                                        <Typography variant="body2" sx={{ml:'2px'}}>{data.amt.toLocaleString()}</Typography>
                                        <Typography variant="body2" sx={{ml:.5}}>ft</Typography>
                                        {data.uom === "lb"
                                        ?
                                        <Typography variant="caption" sx={{ml:2}}>(calc)</Typography>
                                        :
                                        ""
                                        }
                                    </Box>

                                    <Box sx={{display:'flex'}}>
                                        <Typography variant="body2" sx={{fontWeight:'bold'}}>Remaining:</Typography>
                                        <Typography variant="body2" sx={{ml:'2px'}}>{(props.data.amt-props.data.curPullSum).toLocaleString()}</Typography>
                                        <Typography variant="body2" sx={{ml:.5}}>ft</Typography>
                                        {props.data.uom === "lb"
                                        ?
                                        <Typography variant="caption" sx={{ml:2}}>(calc)</Typography>
                                        :
                                        ""
                                        }
                                    </Box>
                                    <LocatorListItemCurLocation  data={props.data}  childIdx={props.childIdx} openChildFx={props.openChildFx} />
                                    <Box sx={{display:'flex'}}>
                                        <Typography variant="body2" sx={{fontWeight:'bold'}}>Ship Date:</Typography>
                                        <Typography variant="body2" sx={{ml:'2px'}}>{(new Date(data.shipDate)).toLocaleDateString("en-US")}</Typography>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Typography variant="body2" sx={{fontWeight:'bold'}}>Age:</Typography>
                                        <Typography variant="body2" sx={{ml:'2px'}}>{(props.data.shipDateDays).toLocaleString()}</Typography>
                                        <Typography variant="body2" sx={{ml:.5}}>Days</Typography>
                                    </Box>

                                </Stack>
                            </Grid>

                            <Grid item xs={6} md={4}>
                                <Stack>
                                    <Box sx={{display:'flex'}}>
                                        <Typography variant="body2" sx={{fontWeight:'bold'}}>Purchase Order:</Typography>
                                        <Typography variant="body2" sx={{ml:'2px'}}>{props.data.customerPo==null?"No Order":props.data.customerPo}</Typography>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Typography variant="body2" sx={{fontWeight:'bold'}}>Shipping Order:</Typography>
                                        <Typography variant="body2" sx={{ml:'2px'}}>{props.data.idSapOrder}</Typography>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Typography variant="body2" sx={{fontWeight:'bold'}}>Packing List No:</Typography>
                                        <Typography variant="body2" sx={{ml:'2px'}}>{props.data.idSapPackingList}</Typography>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Typography variant="body2" sx={{fontWeight:'bold'}}>Bill of Lading No:</Typography>
                                        <Typography variant="body2" sx={{ml:'2px'}}>{props.data.idSapBol}</Typography>
                                    </Box>
                                    <Box sx={{display:'flex'}}>
                                        <Typography variant="body2" sx={{fontWeight:'bold'}}>Batch No:</Typography>
                                        <Typography variant="body2" sx={{ml:'2px'}}>{props.data.idSapBatchNo}</Typography>
                                    </Box>                                    
                                </Stack>
                            </Grid>
                        </Grid>
                    </Stack>
                </Grid>
                
                <Grid item xs={12} sm={4}>
                    <Stack>
                        <Box sx={{...styleHeaders, display:'flex', alignItems:'center', justifyContent:'center'}}>
                            <Typography variant="h6">Reel</Typography>
                        </Box>
                        {/* {
                            props.data.reel!==null
                            ? */}
                            <LocatorListItemReel data={props.data} />
                            {/* :
                            ""
                        } */}
                    </Stack>                          
                </Grid>
            </Grid>
        </Paper>
    )

}

